import React, {useContext, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {Grid} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import Pager from './Pager';
import ItemsPerPageSelector from './ItemsPerPageSelector';
import FilterInput from './FilterInput';
import {calcTableEntriesInfo} from 'utils/translations';
import {I18nContext} from 'contexts/i18n';

const GreatListing = withStyles({
  flexRow: {
    display: 'flex',
    alignItems: 'center',
  },
  childrenSpacing: {
    '&>*': {
      marginRight: 5,
    },
  },
  extraFilters: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexGrow: 1,
  },
})(
  ({
    tableState: {recordPages, initialized, itemsPerPage, filterValue, extraFilters},
    refreshTable,
    selectPage,
    selectItemsPerPage,
    changeFilter,
    changeSorter,
    changeExtraFilters,
    ListingCore,
    ExtraFilters,
    searchInputPlaceholder,
    extraFilterProps = {},
    className,
    disableSearch,
    restProps,
    classes,
  }) => {
    const {i18nTranslate, locale} = useContext(I18nContext);

    return (
      <Grid container spacing={2} className={clsx(className)}>
        <Grid item xs={12}>
          <Grid container spacing={2} alignItems="center">
            <ItemsPerPageSelector
              component={Grid}
              item
              value={itemsPerPage}
              onChange={({target: {value}}) => selectItemsPerPage(value)}
            />
            {!disableSearch && (
              <Grid item className={classes.flexRow}>
                <FilterInput
                  placeholder={i18nTranslate([searchInputPlaceholder || 'Search'])}
                  onChange={(value) => changeFilter(value)}
                />
              </Grid>
            )}
            <Grid item className={classes.extraFilters}>
              {ExtraFilters && (
                <ExtraFilters values={extraFilters} onChange={changeExtraFilters} {...extraFilterProps} />
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <ListingCore
            {...{
              initialized,
              recordPages,
              refreshTable,
              onSortableFieldSet: changeSorter,
              ...restProps,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2} justify="space-between" alignItems="center">
            <Grid item>
              {calcTableEntriesInfo({
                itemsPerPage,
                currentPage: recordPages.currentPage,
                totalCount: recordPages.totalCount,
                locale,
              })}
            </Grid>
            <Grid item>
              <Pager currentPage={recordPages.currentPage} totalPages={recordPages.pageCount} onChange={selectPage} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  },
);

GreatListing.propTypes = {
  ListingCore: PropTypes.func.isRequired,
  tableState: PropTypes.object.isRequired,
  refreshTable: PropTypes.func.isRequired,
  selectPage: PropTypes.func.isRequired,
  selectItemsPerPage: PropTypes.func.isRequired,
  changeFilter: PropTypes.func.isRequired,
  changeSorter: PropTypes.func.isRequired,
  changeExtraFilters: PropTypes.func.isRequired,
  searchInputPlaceholder: PropTypes.string,
  ExtraFilters: PropTypes.any,
  extraFilterProps: PropTypes.object,
  className: PropTypes.string,
  disableSearch: PropTypes.bool.isRequired,
  restProps: PropTypes.object.isRequired,
};

export default (ListingCore, ExtraFilters) =>
  class extends React.Component {
    static propTypes = {
      tableState: PropTypes.object.isRequired,
      refreshTable: PropTypes.func.isRequired,
      selectPage: PropTypes.func.isRequired,
      selectItemsPerPage: PropTypes.func.isRequired,
      changeFilter: PropTypes.func.isRequired,
      changeSorter: PropTypes.func.isRequired,
      changeExtraFilters: PropTypes.func.isRequired,
      searchInputPlaceholder: PropTypes.string,
      ListingCore: PropTypes.func,
      extraFilterProps: PropTypes.object,
      className: PropTypes.string,
      disableSearch: PropTypes.bool.isRequired,
    };
    static defaultProps = {
      disableSearch: false,
    };

    render() {
      const {
        tableState,
        refreshTable,
        selectPage,
        selectItemsPerPage,
        changeFilter,
        changeSorter,
        changeExtraFilters,
        searchInputPlaceholder,
        extraFilterProps,
        className,
        disableSearch,
        ...restProps
      } = this.props;
      return React.createElement(GreatListing, {
        tableState,
        refreshTable,
        selectPage,
        selectItemsPerPage,
        changeFilter,
        changeSorter,
        changeExtraFilters,
        searchInputPlaceholder,
        restProps,
        extraFilterProps,
        className,
        disableSearch,
        ListingCore,
        ExtraFilters,
      });
    }
  };
